import { Box, useTheme } from "@material-ui/core";
import { Palette } from "@material-ui/core/styles/createPalette";
import MappedComponent from "../../../../components/mapped-components/MappedComponent";
import { RefundStatus } from "../../../../models/generated/graphql";
import { LiteBox } from "apps/platform-client/client/src/components/lite/LiteBox";

const getStatusAttributes = (status: RefundStatus, palette: Palette): string => {
	switch (status) {
		case RefundStatus.Pending:
			return palette.error.dark;
		case RefundStatus.New:
			return palette.warning.main;
		case RefundStatus.Invoiced:
			return palette.secondary.dark;
		case RefundStatus.Settled:
			return palette.primary.dark;
		default:
			return palette.primary.dark;
	}
};

export default function StatusColumn(props: { status: RefundStatus; text?: string }) {
	const { palette } = useTheme();
	const { status, text } = props;
	const color = getStatusAttributes(status, palette);

	return (
		<LiteBox color={color}>
			<MappedComponent component="RefundStatusComponent" props={{ status, text }} />
		</LiteBox>
	);
}
